// extracted by mini-css-extract-plugin
module.exports = {"slide":"Carousel_slide__jlPsu","carouselArrowLeft":"Carousel_carouselArrowLeft__w5I9W","carouselArrowRight":"Carousel_carouselArrowRight__g_gAX","dots":"Carousel_dots__qDCbR"};